// Chipnet electrum endpoints — mirrors the wallet's DEFAULT_ENDPOINTS.chipnet
// slice from shells/app/src/core/spv/pool.ts. Two public WSS servers is what
// exists today; the wallet keeps a placeholder for "deviant (own)" when we run
// our own Fulcrum, which we'd add here too.
//
// Update rule: if the shell's pool.ts adds/removes a chipnet endpoint, mirror
// that change here. Kept as a copy (not an import) because the mockup deliberately
// avoids pulling shells/app/ into its bundle — smaller ship, no cross-package
// module resolution.
export const CHIPNET_ENDPOINTS: readonly string[] = [
  'wss://chipnet.bch.ninja:50004',
  'wss://chipnet.imaginary.cash:50004',
  'wss://chipnet.electroncash.de:50004',
  'wss://cbch.loping.net:62104',
];
